import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { FacturaDTO } from "app/main/apps/shared/interfaces/factura.interface";
import { FacturaService } from "app/main/apps/shared/services/rest/factura.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "app-ficha-factura",
    templateUrl: "./ficha-factura.component.html",
    styleUrls: ["./ficha-factura.component.scss"],
})
export class FichaFacturaComponent implements OnInit, OnDestroy {
    @Input() factura: FacturaDTO;
    @Output() toggleEstadoFacturaEvent: EventEmitter<any> = new EventEmitter();

    @ViewChild("checkActivacion", { static: false })
    slideActivacion: MatSlideToggle;

    subscripciones: Subscription;
    constructor(
        private _facturaSrvc: FacturaService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.subscripciones = new Subscription();
    }


    ngAfterViewInit() {
        setTimeout(() => {
            //console.log('xx')
            if (this._menuUsuarioSrvc.esSupervisor()) {
                this.evaluaActivacion();
            }
        });

        this.subscripciones.add(
            this._facturaSrvc.facturaChanged$
                .pipe(distinctUntilChanged())
                .subscribe((resp) => {
                    this.factura = resp;
                    this.evaluaActivacion();
                })
        );

    }


    evaluaActivacion() {
        //console.log("activo", { ...this.factura }.pagada);
        this.slideActivacion.checked = { ...this.factura }.pagada;
    }

    ngOnInit(): void {}

    toggleEstadoFactura(factura) {
        this.toggleEstadoFacturaEvent.emit(factura);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
